export default {
  "HitPaw Add Music to Audio Online": "HitPaw Tambahkan Musik ke Audio Online",
  "Add BGM to Audio without any difficulties.": "Tambahkan BGM ke Audio dengan mudah.",
  "Add New": "Tambah Baru",
  "Format": "Format",
  "Add tracks": "Tambahkan trek",

};
